import { render, staticRenderFns } from "./PackageFaq.vue?vue&type=template&id=a779f164&scoped=true&"
import script from "./PackageFaq.vue?vue&type=script&lang=js&"
export * from "./PackageFaq.vue?vue&type=script&lang=js&"
import style0 from "./PackageFaq.vue?vue&type=style&index=0&id=a779f164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a779f164",
  null
  
)

export default component.exports